import { connect } from "react-redux";
import ModelesList from "./ModelesList";
import { addmportAssortiment, getAllClients, getAllRetailers } from "../../../redux/actions/clientActions";
import { getReferentielsList, init } from "./../../../redux/actions/referentielsActions";
import { setSort } from "../../../redux/actions/referentielsActions";
import { modelDelete } from "../../../redux/actions/modelActions";
import { currentClientSelector } from "../../../redux/selectors/auth";

const mapStateToProps = (state, ownProps) => {
  return {
    modelsList: state.models.modelsList,
    modelsListLoading: state.models.modelsListLoading,
    page: state.models.page,
    pages: state.models.pages,
    pageSize: state.models.pageSize,
    nbItems: state.models.modelsList.length,
    //clientsList: state.client.surveyManager.clientsList,
    //retailersList: state.client.surveyManager.retailersList,
    currentClientLabel: currentClientSelector(state).label,
    currentClientId: currentClientSelector(state).id,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addmportAssortiment: body => {
      dispatch(addmportAssortiment(body));
    },
    getAllClients: () => {
      dispatch(getAllClients());
    },
    getAllRetailers: () => {
      dispatch(getAllRetailers());
    },
    init: sectionName => dispatch(init(sectionName)),
    getNext: page => {
      const nextPage = page;
      dispatch(getReferentielsList({ page: nextPage }, "models"));
    },
    setSort: (column, sortOrder) => dispatch(setSort("models", column, sortOrder)),
    modelDelete: id => {
      dispatch(modelDelete(id));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModelesList);



// WEBPACK FOOTER //
// src/containers/admin/modeles/ModelesContainer.js